import { render, staticRenderFns } from "./address-editor.vue?vue&type=template&id=526c0ac6&scoped=true&"
import script from "./address-editor.vue?vue&type=script&lang=js&"
export * from "./address-editor.vue?vue&type=script&lang=js&"
import style0 from "./address-editor.vue?vue&type=style&index=0&id=526c0ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c0ac6",
  null
  
)

export default component.exports